export default __webpack_public_path__ + "static/media/q.ea4ee9bc.svg";